import React, { useRef, useState } from "react";
import s from "./CarDetails.module.scss";
import { message, Tabs } from "antd";
import ImageGallery from "react-image-gallery";
import { ArrowUpOutlined, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import TabPane from "antd/es/tabs/TabPane";
import "react-image-gallery/styles/css/image-gallery.css";
import { useDispatch, useSelector } from "react-redux";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import CarItem from "../../components/CarItem/CarItem";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import {
  bodyType,
  colors,
  condition,
  driveType,
  fuel,
  inStock,
  registrationCouyntry,
  transmission,
} from "../../data";
import { addComment, getCarDetails, upCar } from "../../redux/carSlice";
import Comment from "../../components/Comment/Comment";
import ReactQuill from "react-quill";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CarDetails = () => {
  const { width } = useWindowDimensions();
  const car = useSelector((state) => state.cars.carDetails);
  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const [userComment, setUserComment] = useState();
  const params = useParams();
  const ref = useRef(null);
  const [parent, setParent] = useState();
  const { t } = useTranslation();

  const executeScroll = () => ref.current.scrollIntoView();

  const success = (message) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };

  const error = (message) => {
    messageApi.open({
      type: "error",
      content: message,
    });
  };

  const upMyCar = async (id) => {
    const res = await dispatch(upCar(id));
    if (res.type === "cars/upCar/rejected") error(res.payload);
    if (res.type === "cars/upCar/fulfilled") success(res.payload.success);
  };

  const sendComment = async () => {
    const res = await dispatch(
      addComment({
        vehicle: car.id,
        parent: parent || null,
        content: userComment,
      })
    );

    if (res.type === "cars/addComment/fulfilled") {
      dispatch(getCarDetails(Number(params.id)));
      setUserComment("");
      setParent(null);
    }
  };

  return (
    <div>
      {contextHolder}
      <div className={s.home}>
        {width > 800 ? <div className={s.left}>Реклама</div> : null}
        <div className={s.main}>
          {width > 1000 ? <div className={s.top}>top</div> : null}
          <div className={s.body}>
            {width > 1200 ? <Header /> : <MobileHeader />}
            <section className={s.main_content}>
              <div className={s.content}>
                <div className={s.header}>
                  <div>
                    <div className={s.title}>
                      {car?.brand?.name}&nbsp;{car?.model?.name}
                    </div>
                    <div className={s.subtitle}>
                      {car?.location?.name} &nbsp;
                      <ArrowUpOutlined className={s.icon} /> Поднято: {car?.up}
                      &nbsp;&nbsp;&nbsp;
                      <PlusOutlined className={s.icon} />
                      &nbsp;Добавлено: {car?.created_at}&nbsp;&nbsp;&nbsp;
                      <EyeOutlined className={s.icon} />
                      &nbsp;{car?.views}
                    </div>
                  </div>
                  <div className={s.price}>
                    <div className={s.price_usd}>$ {car?.price}</div>
                    <div className={s.price_kgs}>{car?.price * 89} сом</div>
                    <div className={s.other_prices}>
                      <div className={s.price_rub}>{car?.price * 90}₽</div>
                      <div className={s.price_kzt}>{car?.price * 444} ₸</div>
                    </div>
                  </div>
                </div>

                <div className={s.buttons}>
                  <button className={s.btn}>{t("urgent")}</button>
                  <button className={s.btn}>
                    <ArrowUpOutlined /> &nbsp; UP
                  </button>
                  <button className={s.btn}>&nbsp; VIP</button>
                </div>

                <div className={s.tabs}>
                  <Tabs defaultActiveKey='1' type='card'>
                    <TabPane tab={t("application")} key='1'>
                      <div className={s.tab1}>
                        <div className={s.car_info}>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>{t("year")}:</div>
                            <div className={s.item_value}>
                              {car?.year_of_manufacture}
                            </div>
                          </div>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>{t("mileage")}:</div>
                            <div className={s.item_value}>
                              {car?.mileage} км
                            </div>
                          </div>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>{t("bodyType")}:</div>
                            <div className={s.item_value}>
                              {
                                bodyType?.find(
                                  (it) => it.value === car?.body_type
                                )?.label
                              }
                            </div>
                          </div>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>{t("color")}:</div>
                            <div className={s.item_value}>
                              {
                                colors?.find((it) => it.value === car?.color)
                                  ?.label
                              }
                            </div>
                          </div>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>{t("volume")}:</div>
                            <div className={s.item_value}>{car?.engine}</div>
                          </div>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>{t("fuelType")}:</div>
                            <div className={s.item_value}>
                              {
                                fuel?.find((it) => it.value === car?.fuel_type)
                                  ?.label
                              }
                            </div>
                          </div>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>
                              {t("transmission")}:
                            </div>
                            <div className={s.item_value}>
                              {
                                transmission?.find(
                                  (it) => it.value === car?.transmission
                                )?.label
                              }
                            </div>
                          </div>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>
                              {t("driveType")}:
                            </div>
                            <div className={s.item_value}>
                              {
                                driveType.find(
                                  (it) => it?.value === car?.drive_type
                                )?.label
                              }
                            </div>
                          </div>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>{t("wheel")}:</div>
                            <div className={s.item_value}>
                              {car?.steering_wheel === "left"
                                ? "Слева"
                                : "Справа"}
                            </div>
                          </div>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>
                              {t("condition")}:
                            </div>
                            <div className={s.item_value}>
                              {
                                condition?.find(
                                  (it) => it.value === car?.condition
                                )?.label
                              }
                            </div>
                          </div>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>
                              {t("customControl")}:
                            </div>
                            <div className={s.item_value}>
                              {car?.customs_clearance ? t("yes") : t("no")}
                            </div>
                          </div>

                          <div className={s.car_info_item}>
                            <div className={s.item_title}>
                              {t("available")}:
                            </div>
                            <div className={s.item_value}>
                              {
                                inStock.find(
                                  (it) => it.value === car?.availability
                                )?.label
                              }
                            </div>
                          </div>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>{t("location")}:</div>
                            <div className={s.item_value}>
                              {car?.location?.name}
                            </div>
                          </div>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>
                              {t("registration")}:
                            </div>
                            <div className={s.item_value}>
                              {
                                registrationCouyntry.find(
                                  (it) => it.value === car?.registration
                                )?.label
                              }
                            </div>
                          </div>
                        </div>
                        <div className={s.car_slider}>
                          <ImageGallery
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showPlayButton={false}
                            items={
                              car &&
                              car.images.length > 0 &&
                              car?.images?.map((it) => ({
                                original: it?.image,
                                thumbnail: it?.image,
                              }))
                            }
                          />
                        </div>
                      </div>
                      <div className={s.comments}>
                        <div className={s.comments_title}>
                          {t("description")}
                        </div>
                        <div
                          className={s.comments_text}
                          dangerouslySetInnerHTML={{
                            __html: car?.seller_comment,
                          }}
                        ></div>
                      </div>
                      <div className={s.comments}>
                        {car?.comments && car?.comments.length > 0 ? (
                          <div className={s.comments_title}>
                            {t("comments")}&nbsp;({car?.comments.length})
                          </div>
                        ) : null}
                        <div>
                          {car?.comments?.map((it) => (
                            <Comment
                              comment={it}
                              setParent={setParent}
                              executeScroll={executeScroll}
                            />
                          ))}
                        </div>
                        <div className={s.comments_title}>
                          {t("writeComment")}
                        </div>
                        <div ref={ref}>
                          <ReactQuill
                            value={userComment}
                            onChange={setUserComment}
                          />
                        </div>
                        <div className={s.button_wrapper}>
                          <button
                            onClick={() => sendComment()}
                            className={s.commentButton}
                          >
                            {t("sendComment")}
                          </button>
                        </div>
                      </div>
                    </TabPane>
                    <TabPane tab={t("features")} key='2'>
                      <div>This is content for Tab 2</div>
                    </TabPane>
                    {/* <TabPane tab='Статистика Цен' key='3'>
                      <div>This is content for Tab 3</div>
                    </TabPane> */}
                  </Tabs>
                </div>
                <div className={s.similar_cars}>
                  <div className={s.comments_title}>{t("similarCars")}</div>
                  <div className={s.similar}>
                    {car?.similar_cars
                      ?.filter((el, index) => index > 4)
                      ?.map((it) => (
                        <div className={s.similar_item}>
                          <CarItem car={it} />
                        </div>
                      ))}
                  </div>
                </div>
                <div className={s.similar_cars}>
                  <div className={s.comments_title}>{t("spares")}</div>
                  <div className={s.similar}>
                    {car?.similar_cars
                      ?.filter((el, index) => index > 4)
                      ?.map((it) => (
                        <div className={s.similar_item}>
                          <CarItem car={it} />
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              {width > 1200 ? (
                <div className={s.sidebar_add}>Реклама</div>
              ) : null}
            </section>
          </div>
        </div>
        {width > 800 ? <div className={s.right}>Реклама</div> : null}
      </div>
      <div className={s.footer}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};
// };

export default CarDetails;
